import { useMutation } from '@tanstack/react-query'
import api from '../../config/axios-config.jsx'
import { projectMutationKeys, projectQueryKeys } from '../constants.js'
import { customQueryClient } from '../../config/query-client.jsx'

export const useUpdateProjectFolderMutation = (options) => {
  const handleMutation = async ({ folderId, body }) => {
    const config = {
      method: 'patch',
      data: body
    }

    const { data } = await api(`/api/v2/projectFolders/${folderId}`, config)

    return data
  }

  const invalidateRelatedQueries = (folderId) => {
    customQueryClient.invalidateQueries({
      queryKey: [projectQueryKeys.GET_PROJECT_TREE_QUERY]
    })
    customQueryClient.invalidateQueries({
      queryKey: [projectQueryKeys.GET_PROJECT_FOLDER_QUERY, folderId]
    })
  }

  return useMutation({
    mutationFn: handleMutation,
    mutationKey: [projectMutationKeys.UPDATE_PROJECT_FOLDER_MUTATION],
    retry: 0,
    ...options,
    onSuccess: (data, variables, context) => {
      const { folderId } = variables
      // Call our standard logic
      invalidateRelatedQueries(folderId)

      // Call user callback with all original parameters
      options?.onSuccess?.(data, variables, context)
    },
    onError: (error, variables, context) => {
      // Call user callback with all original parameters
      options?.onError?.(error, variables, context)
    }
  })
}
